import { ColourItem } from 'approot/shared/colour/colour-token.style';
import {
  COLOUR_AZURE,
  COLOUR_BLACK,
  COLOUR_BLUE,
  COLOUR_CYAN,
  COLOUR_GOLD,
  COLOUR_GREEN,
  COLOUR_GREY,
  COLOUR_LIME,
  COLOUR_MAGENTA,
  COLOUR_ORANGE,
  COLOUR_PURPLE,
  COLOUR_RED,
  COLOUR_VOLCANO,
  COLOUR_YELLOW,
} from 'approot/shared/colour/colour.constants';
import {
  azure3,
  azure8,
  blue3,
  blue8,
  coolGrey2,
  coolGrey8,
  cyan3,
  cyan8,
  gold3,
  gold8,
  green3,
  green8,
  grey1,
  grey10,
  grey5,
  grey6,
  lime3,
  lime8,
  magenta3,
  magenta8,
  orange3,
  orange8,
  purple3,
  purple8,
  red3,
  red8,
  volcano3,
  volcano8,
  yellow3,
  yellow8,
} from 'approot/shared/styles/colours.style';

const buildColourGroup = ({
  colour,
  lightVariant,
  darkVariant,
  name,
  darkName,
  lightName,
}: {
  colour: ColourItem;
  lightVariant: string;
  darkVariant: string;
  name: string;
  darkName: string;
  lightName: string;
}): ColourItem[] => [
  { ...colour, base: darkVariant, name: darkName },
  { ...colour, name },
  { ...colour, base: lightVariant, name: lightName },
];

export const COLOURS = [
  ...buildColourGroup({
    colour: { ...COLOUR_BLACK, base: grey6 },
    lightVariant: grey1,
    darkVariant: grey10,
    name: 'Grey',
    darkName: 'Black',
    lightName: 'White',
  }),
  ...buildColourGroup({
    colour: { ...COLOUR_GREY, base: grey5 },
    lightVariant: coolGrey2,
    darkVariant: coolGrey8,
    name: 'Cool Grey',
    darkName: 'Dark Grey',
    lightName: 'Light Grey',
  }),
  ...buildColourGroup({
    colour: COLOUR_AZURE,
    lightVariant: azure3,
    darkVariant: azure8,
    name: 'Azure',
    darkName: 'Dark Azure',
    lightName: 'Light Azure',
  }),
  ...buildColourGroup({
    colour: COLOUR_BLUE,
    lightVariant: blue3,
    darkVariant: blue8,
    name: 'Blue',
    darkName: 'Dark Blue',
    lightName: 'Light Blue',
  }),
  ...buildColourGroup({
    colour: COLOUR_CYAN,
    lightVariant: cyan3,
    darkVariant: cyan8,
    name: 'Cyan',
    darkName: 'Dark Cyan',
    lightName: 'Light Cyan',
  }),
  ...buildColourGroup({
    colour: COLOUR_GREEN,
    lightVariant: green3,
    darkVariant: green8,
    name: 'Green',
    darkName: 'Dark Green',
    lightName: 'Light Green',
  }),
  ...buildColourGroup({
    colour: COLOUR_LIME,
    lightVariant: lime3,
    darkVariant: lime8,
    name: 'Lime',
    darkName: 'Dark Lime',
    lightName: 'Light Lime',
  }),
  ...buildColourGroup({
    colour: COLOUR_YELLOW,
    lightVariant: yellow3,
    darkVariant: yellow8,
    name: 'Yellow',
    darkName: 'Beige',
    lightName: 'Light Yellow',
  }),
  ...buildColourGroup({
    colour: COLOUR_GOLD,
    lightVariant: gold3,
    darkVariant: gold8,
    name: 'Gold',
    darkName: 'Light Brown',
    lightName: 'Light Gold',
  }),
  ...buildColourGroup({
    colour: COLOUR_ORANGE,
    lightVariant: orange3,
    darkVariant: orange8,
    name: 'Orange',
    darkName: 'Brown',
    lightName: 'Light Orange',
  }),
  ...buildColourGroup({
    colour: COLOUR_VOLCANO,
    lightVariant: volcano3,
    darkVariant: volcano8,
    name: 'Volcano',
    darkName: 'Dark Volcano',
    lightName: 'Light Volcano',
  }),
  ...buildColourGroup({
    colour: COLOUR_RED,
    lightVariant: red3,
    darkVariant: red8,
    name: 'Red',
    darkName: 'Dark Red',
    lightName: 'Light Red',
  }),
  ...buildColourGroup({
    colour: COLOUR_MAGENTA,
    lightVariant: magenta3,
    darkVariant: magenta8,
    name: 'Pink',
    darkName: 'Dark Pink',
    lightName: 'Light Pink',
  }),
  ...buildColourGroup({
    colour: COLOUR_PURPLE,
    lightVariant: purple3,
    darkVariant: purple8,
    name: 'Purple',
    darkName: 'Dark Purple',
    lightName: 'Light Purple',
  }),
];
